module.exports = __webpack_public_path__ + "media/images/icons/hotel-fde80172e32ce0e560e3feec41604d1f.svg";